// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2QQ5W","active":"NavigationItem_active__2KWDo"};